const skills = [
  { label: "Tactical FPS", value: 96 },
  { label: "Battle Royale", value: 88 },
  { label: "Team Coordination", value: 92 },
  { label: "Sniper Precision", value: 85 },
  { label: "Close Quarters Combat", value: 94 },
];

const badges = [
  { icon: "ri-trophy-fill", label: "Tournament Winner", sub: "Regional FPS Champ 2023" },
  { icon: "ri-shield-star-fill", label: "Veteran Status", sub: "16+ Years Active" },
  { icon: "ri-fire-fill", label: "Top Streamer", sub: "10K+ Twitch Followers" },
  { icon: "ri-sword-fill", label: "Clan Leader", sub: "Murks Battalion" },
];

export default function AboutMe() {
  return (
    <section
      id="about"
      className="relative py-28 overflow-hidden"
      style={{
        backgroundImage: `url("https://public.readdy.ai/ai/img_res/ccc590725430f99cb3af74138480735b.jpg")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-urban-dark/90" />

      <div className="relative z-10 max-w-7xl mx-auto px-8 md:px-16">
        <div className="flex items-center gap-4 mb-16">
          <div className="w-1 h-12 bg-red-600" />
          <div>
            <p className="font-rajdhani text-red-500 uppercase tracking-widest text-sm font-semibold">The Man Behind The Legend</p>
            <h2 className="font-bebas text-5xl md:text-6xl text-white tracking-wider">About Me</h2>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <div className="relative">
              <div className="absolute -top-3 -left-3 w-20 h-20 border-t-2 border-l-2 border-red-700/60" />
              <div className="absolute -bottom-3 -right-3 w-20 h-20 border-b-2 border-r-2 border-red-700/30" />
              <div className="w-full h-80 md:h-96 overflow-hidden rounded-sm">
                <img
                  src="https://static.readdy.ai/image/c088ed944a840dff525f6c9a83fbd586/7be84091aa02310197fc44170c112371.png"
                  alt="Mike Barrett"
                  className="w-full h-full object-cover object-top"
                  style={{ filter: "grayscale(20%) contrast(1.1)" }}
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 mt-8">
              {badges.map((b) => (
                <div
                  key={b.label}
                  className="bg-urban-card border border-urban-border rounded-sm p-4 hover:border-red-800/60 transition-colors duration-300"
                >
                  <div className="w-8 h-8 flex items-center justify-center text-red-500 text-xl mb-2">
                    <i className={b.icon} />
                  </div>
                  <p className="font-rajdhani font-bold text-white text-sm">{b.label}</p>
                  <p className="font-rajdhani text-gray-500 text-xs">{b.sub}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-bebas text-4xl text-white tracking-wider mb-2">
              The Legend of <span className="text-red-500">Old Man Murks</span>
            </h3>
            <p className="font-rajdhani text-gray-400 text-base leading-relaxed mb-4">
              They said gaming was for kids. I said hold my controller. My name is <strong className="text-white">Mike Barrett</strong> and I&apos;ve been dominating lobbies since the days of dial-up internet. In a world of sweaty teenagers, I&apos;m the grey-bearded tactician who studied the battlefield before most of them were born.
            </p>
            <p className="font-rajdhani text-gray-400 text-base leading-relaxed mb-4">
              Born and raised in the streets, I bring that real-world street IQ to every game I play. Whether it&apos;s clearing buildings in <strong className="text-red-400">Warzone</strong>, surviving the streets of <strong className="text-red-400">Tarkov</strong>, or breaching and clearing in <strong className="text-red-400">Siege</strong> &mdash; Old Man Murks gets the job done.
            </p>
            <p className="font-rajdhani text-gray-400 text-base leading-relaxed mb-8">
              I started streaming to show the world that experience beats reflexes every single time. My content is raw, tactical, educational, and entertaining. Join the <strong className="text-white">Murks Battalion</strong> and let&apos;s run it.
            </p>

            <div className="space-y-4 mb-8">
              {skills.map((skill) => (
                <div key={skill.label}>
                  <div className="flex justify-between items-center mb-1">
                    <span className="font-rajdhani text-gray-300 text-sm font-semibold uppercase tracking-wider">{skill.label}</span>
                    <span className="font-bebas text-red-500 text-lg">{skill.value}%</span>
                  </div>
                  <div className="h-1.5 bg-urban-border rounded-full overflow-hidden">
                    <div
                      className="h-full bg-gradient-to-r from-red-800 to-red-500 rounded-full"
                      style={{ width: `${skill.value}%` }}
                    />
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-3">
              {["Warzone", "Tarkov", "R6 Siege", "PUBG", "Battlefield", "The Division"].map((game) => (
                <span
                  key={game}
                  className="font-rajdhani text-xs uppercase tracking-widest text-gray-400 border border-urban-border px-3 py-1.5 rounded-sm hover:border-red-700/60 hover:text-red-400 transition-colors cursor-default"
                >
                  {game}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
